<script>
    export default {
        name: "FooterBottomText",
        props: {
            title: {
                type: String,
                default: "Оператор магазина ООО «Проект Ы»",
            },
            subtitle: {
                type: String,
                default:
                    "129226, г. Москва, ул. Сельскохозяйственная, дом 11, корп. 3, эт. 1, пом. II, ком. 1 (РМ47)",
            },
        },
    };
</script>

<template>
    <div class="footer-bottom-text">
        <div class="footer-bottom-text__title">{{ title }}</div>
        <div class="footer-bottom-text__subtitle">{{ subtitle }}</div>
    </div>
</template>

<style lang="scss">
    .footer-bottom-text__title {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 5px;
        }
    }

    .footer-bottom-text__subtitle {
        margin-bottom: 40px;
        font-size: 12px;
        line-height: 18px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 0;
        }
    }
</style>
